/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export default function FileIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d='M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6Z' />
    </SvgIcon>
  )
}
